<div class="call-signals">
	<ic-icon-detail icon="fa fa-bell" class="call-signals-total">
		<div class="info">
			<p class="amount">{{ statistics.callevents_created }}</p>
			<p class="label">{{ 'labels.state.total' | translate }}</p>
		</div>
	</ic-icon-detail>
	<div class="call-signals-handling">
		<div
			class="call-signals-handling-info"
			matTooltip="< {{ 600 | time: 'minutes' }}{{ 'labels.time.minute' | translate }}"
			matTooltipClass="pv-tooltip"
			[matTooltipShowDelay]="300"
		>
			<p class="amount">{{ statistics.callevents_responsewindow_1 }}</p>
			<p class="label">{{ 'labels.alarms.fast' | translate }}</p>
		</div>
		<div
			class="call-signals-handling-info"
			matTooltip="{{ 600 | time: 'minutes' }}{{ 'labels.time.minute' | translate }} - {{ 900 | time: 'minutes' }}{{
				'labels.time.minute' | translate
			}}"
			matTooltipClass="pv-tooltip"
			[matTooltipShowDelay]="300"
		>
			<p class="amount">{{ statistics.callevents_responsewindow_2 }}</p>
			<p class="label">{{ 'labels.alarms.average' | translate }}</p>
		</div>
		<div
			class="call-signals-handling-info"
			matTooltip="> {{ 900 | time: 'minutes' }}{{ 'labels.time.minute' | translate }}"
			matTooltipClass="pv-tooltip"
			[matTooltipShowDelay]="300"
		>
			<p class="amount">{{ statistics.callevents_responsewindow_3 }}</p>
			<p class="label">{{ 'labels.alarms.slow' | translate }}</p>
		</div>
	</div>
</div>
<ic-progress-chart-component [value]="statistics.callevents_average_canceltime" [end]="end" [intervals]="intervals">
	<ng-template #title>
		<div class="title">
			<span>
				{{ 'labels.alarms.handledByAlarmModule' | translate }}
				<p>({{ statistics.callevents_cancelled }} / {{ statistics.callevents_created }})</p>
			</span>
			<ic-indicator icon="fa fa-info-circle" text="{{ 'labels.alarms.help.handledByAlarmModule' | translate }}">
			</ic-indicator>
		</div>
	</ng-template>
	<ng-template #legend>
		<p *ngIf="statistics.callevents_average_canceltime" class="legend">
			{{ statistics.callevents_average_canceltime | time: 'minutes' }}{{ 'labels.time.minute' | translate }}
			{{ statistics.callevents_average_canceltime | time: 'seconds' }}{{ 'labels.time.seconds' | translate }}
		</p>
	</ng-template>
</ic-progress-chart-component>
<ic-progress-chart-component [value]="statistics.callevents_average_closetime" [end]="end" [intervals]="intervals">
	<ng-template #title>
		<div class="title">
			<span>
				{{ 'labels.alarms.handledByApp' | translate }}
				<p>({{ statistics.callevents_closed }} / {{ statistics.callevents_created }})</p>
			</span>
			<ic-indicator icon="fa fa-info-circle" text="{{ 'labels.alarms.help.handledByApp' | translate }}"> </ic-indicator>
		</div>
	</ng-template>
	<ng-template #legend>
		<p *ngIf="statistics.callevents_average_closetime" class="legend">
			{{ statistics.callevents_average_closetime | time: 'minutes' }}{{ 'labels.time.minute' | translate }}
			{{ statistics.callevents_average_closetime | time: 'seconds' }}{{ 'labels.time.seconds' | translate }}
		</p>
	</ng-template>
</ic-progress-chart-component>
